import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "MD3",
  "use": "MD3-usage",
  "viewBox": "0 0 64 23",
  "content": "<symbol viewBox=\"0 0 64 23\" xmlns=\"http://www.w3.org/2000/svg\" id=\"MD3\"><title>MD3</title><path d=\"M2.196 0l.006.029 4.706 20.117L11.588 0h2.197v23H12.29V2.918l-4.643 20.05H6.105L1.397 2.977V23H0V0h2.196zm30.352 0c3.153 0 4.923 1.94 5.008 5.468l.003.268v11.528c0 3.609-1.694 5.636-4.777 5.732l-.234.004h-4.979V0h4.979zm20.157 0v23h-1.55V0h1.55zm5.648 0v23h-1.55V0h1.55zM64 0v23h-1.55V0H64zM32.516 1.451h-3.397v20.098h3.397c1.551 0 3.393-.694 3.489-3.95l.004-.27V5.671c0-2.721-1.24-4.22-3.493-4.22z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol